// extracted by mini-css-extract-plugin
export default {"privacy-container":"Privacy_privacy-container__TBeT7","privacy-section":"Privacy_privacy-section__cJ2fL"};